<mat-card [class.selected]="selected">
    <div class="card-container">
        <ng-content select="[card-icon]"></ng-content>
        <div class="mat-subheading-2 cart-description" fxLayoutAlign="start center">
            <ng-content select="[card-description]"></ng-content>
        </div>
    </div>
</mat-card>